import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';

const ScreenRecordMain = styled.div`
  .e-rte-video .e-video-inline {
    width: 355px !important;
  }
  .video-preview {
    border-radius: 6px;
    padding: 6px 0px;
    gap: 12px;
    flex-direction: row-reverse;
    justify-content: flex-end;
    border: none;
    max-width: unset;
    :last-child {
      padding-bottom: 0px;
    }
    .screen-recording-name {
      font-size: 13px;
      line-height: 20px;
    }
    .screen-recording-header {
      padding: 0;
      border-bottom: none;
    }
    .inbox-video {
      width: 86px;
      height: 72px;
      border-radius: 4px;
      border: 0.5px solid var(--border-primary);
    }
  }
  .header {
    display: flex;
    gap: 6px;
    align-items: center;
  }
`;

const Printscreen = styled.div`
  width: fit-content;
  border-radius: 8px;
  padding: 6px 0;
  background-color: var(--background-primary);
  :last-child {
    padding-bottom: 0px;
  }
  .prnt-screen-box {
    flex-direction: row-reverse;
    gap: 12px;
    -webkit-box-align: center;
    align-items: center;
  }
  .prnt-screen-header {
    padding: 0;
    border-bottom: none;
  }
  .prnt-screen-text {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .ant-image-img {
    object-fit: contain;
  }
  .ant-image {
    background-color: var(--border-primary) !important;
    border-radius: 4px;
  }

  .ant-image .ant-image-mask {
    border-radius: 6px;
  }
  .ant-image {
    margin: 0;
  }
  .logo {
    width: 20px;
    height: 20px;
  }
  .header {
    display: flex;
    gap: 6px;
    align-items: center;
  }
  .buttons {
    display: flex;
    gap: 12px;
    ${mobile_xl(css`
      flex-direction: column;
      width: max-content;
    `)}
  }
  a {
    text-decoration: none;
  }
  .custom-mask-content {
    height: 28px;
  }
`;
const SvgDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .img-cleanShot {
    width: 20px;
    height: 20px;
  }
`;

export { ScreenRecordMain, Printscreen, SvgDiv };
